export enum CampaignSetupAgentToolName {
  DeleteCard = 'deleteCard',
  GetCardDetails = 'getCardDetails',
  GetConditionSignal = 'getConditionSignal',
  AddOrUpdateConditionCard = 'addOrUpdateConditionCard',
  GetCreatives = 'getCreatives',
  GetContentFeeds = 'getContentFeeds',
  GetContentSignals = 'getContentSignals',
  GetContentFeedColumns = 'getContentFeedColumns',
  GetContentSets = 'getContentSets',
  CardsConnection = 'cardsConnection',
  MatchStrategy = 'matchStrategy',
  GetLocationFeeds = 'getLocationFeeds',
  GetLocationSets = 'getLocationSets',
  GetProductFeeds = 'getProductFeeds',
  GetProductMatchingSignal = 'getProductMatchingSignal',
  GetProductFeedColumns = 'getProductFeedColumns',
  AutoArrangeCards = 'autoArrangeCards',
  SearchFeedValues = 'searchFeedValues',
  SearchObjects = 'searchObjects',
  ReadValuesFromExcel = 'readValuesFromExcel',
  VerifyCampaignPath = 'verifyCampaignPath',
  GetSelectionStrategies = 'getSelectionStrategies',
  NavigateToCampaignsLibrary = 'navigateToCampaignsLibrary',
}
